<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { loginService } from '@/services/api';
import InputText from 'primevue/inputtext';
import Card from 'primevue/card';
import Button from 'primevue/button';

const email = ref('')
const password = ref('')
const loading = ref(false);
const error = ref('')
const router = useRouter()

async function login() {
  loading.value = true;
  try {
    const res = await loginService(email.value, password.value);
    if (res.token) {
      localStorage.setItem('authToken', res.token)
      await router.push('/')
    } else {
      error.value = 'Invalid credentials'
    }
  } catch (e) {
    error.value = 'Login failed'
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <div class="min-h-screen w-full flex justify-center items-center">
    <Card class="w-80">
      <template #content>
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-2">
            <label for="email">Email</label>
            <InputText id="email" v-model="email" />
          </div>
          <div class="flex flex-col gap-2">
            <label for="password">Password</label>
            <InputText id="password" type="password" v-model="password" />
          </div>
          <p v-if="error" class="text-red-500">{{ error }}</p>
          <Button label="Log in" @click="login" fluid :loading="loading" />
        </div>
      </template>
    </Card>
  </div>
</template>
